<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                        </span>
                    </h2>
                </v-row>

                <!-- Card 1: form fields, ends after Disable checkbox -->
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n5">
                       <v-text-field
                                outlined
                                :label="this.$t('Setupformsetup.formcode')"
                                type="text"
                                ref="formcode"
                                :rules="[rules.required]"
                                v-model="formData.formcode"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('Setupformsetup.formsetupname')"
                                type="text"
                                ref="formname"
                                :rules="[rules.required]"
                                v-model="formData.formname"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('columns.type')"
                            type="text"
                            ref="type"
                            :rules="[rules.required]"
                            v-model="formData.formtype"
                            :items="typeList"
                            @change="updateValue"
                            dense
                        ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row v-if="formData.formtype == 'R'">
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete
                            outlined
                            :label="$t('pmformsetup.rankmapset')"
                            type="text"
                            ref="pmrankmapsetid"
                            v-model="formData.pmrankmapsetid"
                            :items="rankMapSetList"
                            @change="updateValue"
                            dense
                        ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('pmformsetup.maxscore')"
                                type="number"
                                ref="maxscore"
                                :rules="[rules.required]"
                                v-model="formData.maxscore"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('pmformsetup.weightingunit')"
                            type="text"
                            ref="weightingunit"
                            :rules="[rules.required]"
                            v-model="formData.weightingunit"
                            :items="weightingUnitList"
                            @change="updateValue"
                            dense
                        ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="6" class="pb-n4 mt-n8">
                            <v-checkbox
                                outlined
                                ref="disable"
                                v-model="formData.disable"
                                :label="this.$t('columns.disable')"
                                @change="updateValue"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>

                <!-- Save & Cancel only, full-width bar between the two cards -->
                <app-formbuttons
                    v-on:SavePressed="saveHandler"
                    v-on:CancelPressed="cancelHandler"
                />

                <!-- Card 2: Section table, edit mode only -->
                <v-container v-if="isEdit" class="custom-form overflow-y-auto px-5 mt-4">
                    <v-row>
                        <v-col cols="6" sm="6" class="blue--text">
                            {{$t('Setupformsetup.section')}}
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <app-table
                                v-bind:parentObject="{
                                    tabHeader: this.tabHeader,
                                    sectionTypeList: this.sectionTypeList,
                                    formtype: this.formData.formtype,
                                    reviewform : this.formData,
                                    pmreviewformid : this.parentObject.data.id,
                                }"
                                v-on:input="addItemHandler"
                            />
                        </v-col>
                    </v-row>
                </v-container>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            formData: {
                id: this.parentObject.data.id,
                formcode: this.parentObject.data.formcode,
                formname: this.parentObject.data.formname,
                disable: this.parentObject.data.disable,
                formtype: this.parentObject.data.formtype,
                maxscore: this.parentObject.data.maxscore,
                weightingunit: this.parentObject.data.weightingunit,
                pmrankmapsetid: this.parentObject.data.pmrankmapsetid,
                pmgridranksetid : this.parentObject.data.pmgridranksetid,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },

            typeList: [
                { text: this.$t('Setuprankingset.rank'), value: 'R' },
                { text: this.$t('pmreviewexercise.grid'), value: 'G' }
            ],

            weightingUnitList: [
                { text: this.$t('columns.percentage'), value: 'P' },
                { text: this.$t('columns.number'), value: 'N' },
            ],

            rankMapSet: [],
            rankMapSetList: [],
            sectionType: [],
            sectionTypeList: [],
      
            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,

              tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('Setupformreviewsection.section'), value: 'sectname', width: '100px', sortable: false},
                { text: this.$t('Setupformreviewsection.description'), value: 'description', width: '200px', sortable: true},
                { text: this.$t('Setupformreviewsection.weightage'), value: 'sectweightage', width: '200px', sortable: true},
                // { text: this.$t('Setupformreviewsection.dimension'), value: 'dimension', width: '200px', sortable: true},
                { text: this.$t('Setupformreviewsection.sectiontype'), value: 'pmsectiontype', width: '200px', sortable: true},
                { text: this.$t('Setupformreviewsection.displayoption'), value: 'pmdisplayoptiontext', width: '200px', sortable: true},
            ],
        }
    },

    methods: {

        addItemHandler($event) {
            this.formData.rankmapsetdetail=$event
    
            this.updateValue();
        },

        loadRankMapSet() {
            const vm = this;
            this.$store.dispatch('get', {url: "/rankmapset/active/all"})
            .then(function (res) {
            vm.rankMapSet = res.data.rec;
    
            for (let i = 0; i < vm.rankMapSet.length; i++) {
                vm.rankMapSetList.push({
                text: vm.rankMapSet[i].rankmapset,
                value: vm.rankMapSet[i].id,
                });
            }
            })
            .catch(function (err) {
            vm.errMsg = err;
            });
        },

        loadSectionType() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewform/sectiontype/all"})
            .then(function (res) {
            vm.sectionType = res.data.rec;
    
            for (let i = 0; i < vm.sectionType.length; i++) {
                vm.sectionTypeList.push({
                text: vm.sectionType[i].description,
                value: vm.sectionType[i].id,
                });
            }
            })
            .catch(function (err) {
            vm.errMsg = err;
            });
        },

        updateValue() {
            this.$emit('input', {
                formcode: this.formData.formcode,
                formname: this.formData.formname,
                disable: this.formData.disable,
                formtype: this.formData.formtype,
                maxscore: this.formData.maxscore,
                weightingunit: this.formData.weightingunit,
                pmrankmapsetid: this.formData.pmrankmapsetid,
                pmgridranksetid: this.formData.pmgridranksetid,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'formsetuplist'});
        },
    },

    mounted() {
        this.loadRankMapSet();
        this.loadSectionType();
    }
    
}
</script>